/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_TitleInputs */

const es_tyc_title = /** @type {(inputs: Tyc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminos y Condiciones`)
};

const en_tyc_title = /** @type {(inputs: Tyc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms and Conditions`)
};

/**
* | output |
* | --- |
* | "Terms and Conditions" |
*
* @param {Tyc_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_title = /** @type {((inputs?: Tyc_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_title(inputs)
	return en_tyc_title(inputs)
});
export { tyc_title as "tyc.title" }